import { Columns3 } from 'lucide-react';

export function ListConfigureButton(props: { onClick: () => void; title?: string }) {
  return (
    <button
      type="button"
      className="btn-secondary text-xs inline-flex items-center gap-1.5 shrink-0"
      onClick={props.onClick}
      title={props.title ?? 'Configure table columns'}
    >
      <Columns3 className="w-3.5 h-3.5" />
      Configure
    </button>
  );
}
